module.exports = __webpack_public_path__ + "static/media/simplesocial.f679c800.jpg";